var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3C10.5512 3 12.022 3.53818 13.3024 4.53455C14.5829 5.52364 15.6732 6.97091 16.4561 8.78182C16.5146 8.92 16.5146 9.08 16.4561 9.21091C14.8902 12.8327 12.1024 15 9 15H8.99268C5.89756 15 3.10976 12.8327 1.5439 9.21091C1.48537 9.08 1.48537 8.92 1.5439 8.78182C3.10976 5.16 5.89756 3 8.99268 3H9ZM9 6.09091C7.38293 6.09091 6.07317 7.39273 6.07317 9C6.07317 10.6 7.38293 11.9018 9 11.9018C10.6098 11.9018 11.9195 10.6 11.9195 9C11.9195 7.39273 10.6098 6.09091 9 6.09091ZM9.00088 7.18022C10.0033 7.18022 10.8228 7.99476 10.8228 8.9984C10.8228 9.99476 10.0033 10.8093 9.00088 10.8093C7.99112 10.8093 7.17161 9.99476 7.17161 8.9984C7.17161 8.87476 7.18624 8.7584 7.20819 8.64204H7.24478C8.05698 8.64204 8.71551 8.00204 8.74478 7.20204C8.82527 7.18749 8.91307 7.18022 9.00088 7.18022Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.ef36df1d.svg";
export { ForwardRef as ReactComponent };